<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006">
<p class="Ahead"><span epub:type="pagebreak" id="pageix" title="ix"></span></p>
<p class="_ded" id="_idParaDest-3">Dedication</p>
<p class="tx-ni">For the Morrigan. I am grateful for your gifts and victories.</p>
<p class="tx">For Catrina, Sonja, and Terry, for being my comrades in our many adventures. Even when I accidently forget I have volunteered us for rituals. Or when I accidently lock us all out of hotel rooms, cars, and other various places.</p>
<p class="tx">For all those who have helped me make the Morrigan’s Call a reality these many years. It has been an honor weaving magic together with you. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?a0831a48